import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export const columns = [
    {
        name: 'Foto Perfil',
        selector: row => <figure >
                <img 
                    src={row.photoURL} 
                    alt='imagen' 
                    style={{height: '100%', width: '100%'}}
                />
            </figure>
    },
    {
        name: 'Nombre',
        selector: row => row.displayName
    },
    {
        name: 'Correo',
        selector: row => row.email
    },
    {
        name: 'Fecha',
        selector: row => moment(row.date).fromNow()
    },
    {
        name: 'Estado',
        selector: row => row.state === true ? <span style={{color: 'green'}}>Activo</span> : <span style={{color: 'red'}}>Inactivo</span>
    }
    ,
    {
        name: 'Acciones',
        selector: row => row.state === true 
        ?<button className='btn_docente_danger' onClick={() => console.log(row.id)}>Desactivar</button>
        :<button className='btn_docente_success' onClick={() => console.log(row.id)}>Activar</button>
    }
]

export const paginationOptions = {
    rowsPerPageText: 'Filas por pagina',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'todos'
}